module.exports = __webpack_public_path__ + "static/media/particles-2.674adafe.svg";